(function(){
  function norm(s){return (s||'').toLowerCase().replace(/[^a-z0-9]/g,'')}

  /* product page: drop the lines that only repeat the title */
  function pdp(){
    var d=document.querySelector('.autopart-header__description'),t=document.querySelector('.autopart-header__title');
    if(!d||!t)return;
    var title=norm(t.textContent),kids=[].slice.call(d.children);
    for(var i=0;i<kids.length;i++){
      var n=norm(kids[i].textContent);
      if(n===''||(n.length>3&&title.indexOf(n)>-1)){kids[i].style.display='none';continue}
      break;
    }
  }

  /* collection pages: do not show sold-out items */
  function sold(){
    var g=document.getElementById('product-grid');if(!g)return;
    g.querySelectorAll('li.grid__item').forEach(function(li){
      var b=li.querySelector('.card__badge .badge');
      if(b&&/sold out/i.test(b.textContent))li.style.display='none';
    });
  }

  /* prices: show £12.58 instead of £12.58 GBP */
  function gbp(){
    document.querySelectorAll('.price-item,.price__regular,.price__sale').forEach(function(e){
      var w=document.createTreeWalker(e,NodeFilter.SHOW_TEXT),n;
      while(n=w.nextNode()){if(/\sGBP\b/.test(n.nodeValue))n.nodeValue=n.nodeValue.replace(/\s*GBP\b/g,'')}
    });
  }

  function all(){sold();gbp()}
  function init(){
    pdp();all();
    if(window.MutationObserver){
      var c=document.getElementById('ProductGridContainer')||document.querySelector('main');
      if(c)new MutationObserver(all).observe(c,{childList:true,subtree:true,characterData:true});
    }
  }
  document.readyState!=='loading'?init():document.addEventListener('DOMContentLoaded',init);
})();
